export var AnimationMode = /*#__PURE__*/function (AnimationMode) {
  AnimationMode["auto"] = "auto";
  AnimationMode["increase"] = "increase";
  AnimationMode["decrease"] = "decrease";
  AnimationMode["random"] = "random";
  return AnimationMode;
}(AnimationMode || {});